<template>
  <delay-hydration>
    <slot></slot>
  </delay-hydration>
</template>
